import React, { Fragment } from 'react';
import Switch from 'react-toggle-switch';
import utils from '@utils';

const locationsColumns = (timeZoneId) => [
	{
		property : 'AuthorizedOn',
		cell     : {
			formatters : [
				(value, { rowData : { CreatedDate } }) => (
					<Fragment>
						<small className="color-dark">Authorized on</small>
						<small className="font-bold display-block">{ utils.parseUTCDateToTimeZone(CreatedDate, timeZoneId).format('MMM D, YYYY') }</small>
					</Fragment>
				),
			],
		},
	},
	{
		property : 'Location',
		cell     : {
			formatters : [
				(value, {
					rowData : {
						Name, StreetAddress1, StreetAddress2, City, State,
					},
				}) => (
					<Fragment>
						<small className="color-dark">{ Name }</small>
						<small className="font-bold display-block">{ StreetAddress1 }</small>
						<If condition={StreetAddress2}>
							<small className="font-bold display-block">{ StreetAddress2 }</small>
						</If>
						<small className="font-bold display-block">
							<If condition={City}>
								{ City }
								,
							</If>
							{ State }
						</small>
					</Fragment>
				),
			],
		},
	},
	{
		property : 'RKPay',
		header   : {
			label    : 'RKPay',
			sortable : false,
		},
		cell : {
			formatters : [
				() => (
					<Switch
						on
						className="coordinator-toggle-switch"
						onClick={() => {}}
					/>
				),
			],
		},
	},
];

export default locationsColumns;
